export default {
      id: "logo-group-usage",
      viewBox: "0 0 218 35",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#logo-group",
      toString: function () {
        return this.url;
      }
    }